<button id="runsubmitpopup" style="display:none;" data-toggle="modal" data-target="#run_submit_newpopup"></button>
<div class="modal fade " id="run_submit_newpopup" role="dialog">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Submit for Competition</h4>
      </div>
      <div class="modal-body">
        <div class="center">
          <p>Are you sure you want to submit your decisions?</p>
        <p>Note: You may not edit your decisions for this quarter after clicking Submit.</p>
      </div><br>
        <div class="center">
          <div class="row" >
            <div>
              <button type="button" (click)="submitForm()" class="btn btn-primary comman_btn  remove_margin_top" data-dismiss="modal">Submit</button>
              <button type="button" class="btn btn-primary comman_btn remove_margin_top" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
